import { fn } from 'storybook/test';

import type { Meta, StoryFn } from '@storybook/react';
import type { MenuButtonProps } from './MenuButton';

import { MenuButton } from './MenuButton';

const codeString = `
// Has all LabelHTMLAttributes props available except "className" and "style" 
 <MenuButton variant={variant} onClick={onClickFunction} onKeyDown={onKeyDown} onKeyUp={onKeyUp} buttonRef={buttonRef}>{children}</MenuButton>
`;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Buttons/MenuButton',
  component: MenuButton,
  argTypes: {
    variant: {
      options: ['primary', 'secondary', 'destructive-primary', 'destructive-secondary', 'blank', 'blank-icon'],
      control: { type: 'radio' },
    },
  },
  parameters: {
    inspectComponent: MenuButton,
    codeString: codeString,
  },
} as Meta<MenuButtonProps>;

const Template: StoryFn<MenuButtonProps> = (args) => <MenuButton {...args} />;

const defaultArgs: Partial<MenuButtonProps> = {
  variant: 'primary',
  onClick: fn(),
};

export const MenuButtonExample = Template.bind({});
MenuButtonExample.args = {
  children: 'Click me!',
  ...defaultArgs,
};

export const WithIconChildren = Template.bind({});
WithIconChildren.args = {
  ...defaultArgs,
  iconName: 'EllipsisVertical',
};

WithIconChildren.argTypes = {
  ...WithIconChildren.argTypes,
  children: {
    table: {
      disable: true, // Disable children controls for this specific story
    },
  },
};

export const WithMultipleChildren = Template.bind({});
WithMultipleChildren.args = {
  ...defaultArgs,
  children: (
    <>
      <div>Child 1</div>
      <div>Child 2</div>
    </>
  ),
};

WithMultipleChildren.argTypes = {
  ...WithMultipleChildren.argTypes,
  children: {
    table: {
      disable: true, // Disable children controls for this specific story
    },
  },
};
